/** Chaves de localStorage usadas pelo módulo de notificações (logout limpa prefs + inbox). */
export const NOTIFICATION_PREFS_KEY = "xpro_notification_prefs_v1";
export const NOTIFICATION_INBOX_LOCAL_KEY = "xpro_notification_inbox_local_v1";
export const NOTIFICATION_BANNER_DISMISS_KEY = "xpro_notification_banner_dismissed_v1";

/** Limpa dados sensíveis / por usuário; mantém banner dismiss (estado do navegador). */
export function clearNotificationStorageForLogout() {
  try {
    localStorage.removeItem(NOTIFICATION_PREFS_KEY);
    localStorage.removeItem(NOTIFICATION_INBOX_LOCAL_KEY);
  } catch {
    /* ignore */
  }
}
